/**
 * beaut-635. The backend refuses to complete a visit while a line is on a
 * deleted service (400, code DELETED_SERVICE_IN_VISIT). Returns the unique
 * service names for that refusal, or null for any other error.
 */
export function deletedServiceNames(error: unknown): string[] | null {
  const body = (error as any)?.error;
  if (body?.code !== 'DELETED_SERVICE_IN_VISIT') return null;
  const names = (Array.isArray(body.services) ? body.services : [])
    .map((s: any) => s?.name)
    .filter((n: unknown): n is string => typeof n === 'string' && n.length > 0);
  return [...new Set<string>(names)];
}
